import {
  startLastButtonLoading,
  stopButtonLoading,
} from "../utility/buttonLoading";

const isPendingAction = (action) => action.type?.endsWith("/pending");
const isSettledAction = (action) =>
  action.type?.endsWith("/fulfilled") || action.type?.endsWith("/rejected");

const buttonLoadingMiddleware = () => (next) => (action) => {
  const requestId = action.meta?.requestId;

  if (requestId && isPendingAction(action)) {
    startLastButtonLoading(requestId);
  }

  const result = next(action);

  if (requestId && isSettledAction(action)) {
    stopButtonLoading(requestId);
  }

  return result;
};

export default buttonLoadingMiddleware;

